import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Animate, AnimateKeyframes, AnimateGroup } from 'react-simple-animate';
import DriverAdditionstowage from './driver-additionstowage.jsx';

export default class DriversAdditionstowages extends Component {
  constructor(props) {
    super(props);
    this.state = {
      drivers_additionstowages_accounts:  null,
      isLoading: false,
      url: props.url || '/api/v1/portal/drivers/additionstowages',
    };


    this.getDriversAdditionstowages();
  }

  getDriversAdditionstowages() {
    let url = this.state.url;
    return fetch(url, {
      method: "GET",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "Authorization": 'Bearer '+window.api_token
        ,"Accept": 'application/json'
      },
    }).
    then((responseText) => {
      let response = responseText.json();
      response.then((driversExcessAccountsJson) => {
        this.setState({
          drivers_additionstowages_accounts: driversExcessAccountsJson,
          isLoading: false,
        });
      });
    });
  }

  render() {
    let DriversAdditionstowages = [];

    if (this.state.drivers_additionstowages_accounts &&
        this.state.drivers_additionstowages_accounts.length > 0) {
        this.state.drivers_additionstowages_accounts.forEach(
          function(i) {
            DriversAdditionstowages.push(
              <DriverAdditionstowage
                key={'drivers-additionstowages-'+i.id}
                data={i}
              />);
          }
       );
    }
    return (
      <div>
      {
        this.state.isLoading ?
        (<div className="loading-box">
          <span className="add-loading-text">
            <i className="fa fa-spinner fa-pulse"></i>
          </span>
        </div>) :
          <div>{DriversAdditionstowages}</div>
      }
      </div>
    );
  }
}

if (document.getElementById(
  'react-component-g4-logistics-portal-drivers-additionstowages')) {
  ReactDOM.render(
    <DriversAdditionstowages
      url = {"/api/v1/portal/drivers/additionstowages"}
      message_if_none = 'Excessses not found or available for viewing.'
    />,
    document.getElementById(
      'react-component-g4-logistics-portal-drivers-additionstowages'
    )
  );
}
